import type { IArtistResponseBody } from '../../../types/response/IArtistResponseBody';

export class SimpleArtist {
  constructor(
    private readonly _name: string,
    private readonly _shortName: string | null,
    private readonly _artistId: string
  ) {}

  get name(): string {
    return this._name;
  }

  get shortName(): string | null {
    return this._shortName;
  }

  get artistId(): string {
    return this._artistId;
  }

  static fromResponse(response: IArtistResponseBody): SimpleArtist {
    return new SimpleArtist(response.name, response.shortName, response.artistId);
  }
}
